import React from 'react';
import { useIncident } from '../context/incidentContext';
import { complianceArea } from '../incidentData';

export default function IncidentFilters() {
  const { records, filters, updateFilter, filtersOpen, resetFilters } = useIncident();
  if (!filtersOpen) return null;
  const people = [...new Map(records.filter(row => row.referredTo?.id).map(row => [row.referredTo.id, row.referredTo])).values()];
  return <div className="mb-6 flex flex-wrap items-end gap-3 rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
    <label className="text-xs font-semibold text-slate-600">Assigned to
      <select aria-label="Filter assigned person" value={filters.assignee} onChange={event => updateFilter('assignee', event.target.value)} className="ml-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs">
        <option value="">Everyone</option><option value="none">Unassigned</option>
        {people.map(person => <option key={person.id} value={person.id}>{person.fullName}</option>)}
      </select>
    </label>
    <label className="text-xs font-semibold text-slate-600">Compliance area
      <select aria-label="Filter compliance area" value={filters.category} onChange={event => updateFilter('category', event.target.value)} className="ml-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs">
        <option value="">All areas</option>
        {[...new Set(records.map(complianceArea))].sort().map(category => <option key={category}>{category}</option>)}
      </select>
    </label>
    <label className="flex items-center gap-2 text-xs font-semibold text-slate-600"><input type="checkbox" checked={filters.olderThan7} onChange={event => updateFilter('olderThan7', event.target.checked)} />Outstanding over 7 days</label>
    <button type="button" onClick={resetFilters} className="text-xs font-semibold text-blue-600">Reset filters</button>
  </div>;
}
